import(/* webpackMode: "eager" */ "/app/apps/web/src/app/[locale]/(public)/terms-of-use/components/TermsOfUsePage.tsx")